<template>
  <b-overlay :show="showoverlay" rounded="sm" class="full-overlay">
    <div class="pt-3">
      <template v-if="showfilter">
        <div class="ibox clearfix">
          <div class="row col-md-12 no-margin head_blue_radius">
            <div class="col-9">
              <div class="pt-3 pb-3 text-left">
                <span>Current Selected: </span>
                <strong class="susd-head">{{ title }}</strong>
              </div>
            </div>
          </div>

            <!-- Report Period Section -->
            <div class="row col-md-12 no-margin">

                <div class=" col-6 "><!--Audit Update v1-->
                        <period-selector
                        section-title="Report Period"
                        section-id="report"
                        :audit_id = "audit_id"
                        @dates-changed="onDatesChanged"
                    /><!--Audit Update v1-->

                   
                </div>
                <div class=" col-2 "><!--Audit Update v1-->
                 
                </div>
                
                <div class=" col-4 ">
                    <div class="row no-margin pt-4 pb-3">
                        <div class="col-12 text-right pt-5">
                            <!-- Mustafijur: 24-06-2026: Start -->
                            <!-- <b-button class="custom-wizard-btn float-right" type="submit" variant="primary"
                          @click="generateReport(1)"><b-icon icon="file-earmark-excel" class="mr-2"></b-icon>Download
                          Report</b-button> -->

                          <b-button
                                type="submit"
                                variant="primary"
                                size="lg"
                                @click="generateReport(1)"
                                style="width: fit-content;">
                                <b-icon icon="filter" style="margin: 0px 5px;"></b-icon>
                                Download Report
                            </b-button>
                            <!-- Mustafijur: 24-06-2026: End -->
                        </div>
                    </div>   
                </div>

                <div class=" col-12">
                 <template v-if="show_personal_info == true"> <!-- Rejwan: 29-11-2025 -->
                      <!-- Mustafijur: 24-06-2026: Commented: Start -->
                      <!-- <div class="col-sm-12 row mb-3 mt-3 ml-1"> 
                        <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" >
                            <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                                <b-dropdown-form>
                                    <b-form-group @submit.stop.prevent>
                                        <div class="form-group">
                                            <b-form-checkbox-group
                                                v-model="column_selected"
                                                :options="column_options"
                                                switches

                                            />
                                        </div>
                                        <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                    </b-form-group>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                        <div class="d-inline-block ml-3 pt-2">

                            <template v-if="column_selected.length > 0">

                                <div class="d-flex selecte_column_list">
                                    <div class="selecte_column_list_item_wrapper" v-for="(data, n) in column_selected" :key="n">
                                        <div class="selecte_column_list_item">
                                        <span class="name">
                                                {{stringView(data)}}
                                        </span>
                                        <span class="cross" @click="updateSelected(data)">
                                            <img v-bind:src="$api_url+'/images/close.svg'" class="img-fluid cursor-pointer" />
                                        </span>
                                        </div>

                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <span class="none-selected">None Selected.</span>
                            </template>
                          
                        </div>
                      </div> -->
                      <!-- Mustafijur: 24-06-2026: Commented: Start -->
                  </template>
                </div>
                <!-- Start: Rejwan: 29-11-2025 -->
                <div class="col-2 ml-3 mb-2">
                  <template v-if="show_personal_info_choice == true">
                      <div class="title mr-2 mt-2">Show Personal Info</div>
                      <div class="value mr-2">
                          <b-form-select v-model="show_personal_info">
                              <b-form-select-option :value="true">Yes</b-form-select-option>
                              <b-form-select-option :value="false">No</b-form-select-option>
                          </b-form-select>
                      </div>
                  </template>
                </div>
                <!-- End: Rejwan: 29-11-2025 -->
            </div>
        </div>


      </template>
    </div>
  </b-overlay>
</template>

<script>
import Terms from '../../../../../../resources/js/components/Terms.vue';
export default {
  components: { Terms },
  props: ['pageurl', 'is_audit', 'audit_id','selected_reporttype','title'],
  data() {
    return {
      showoverlay: false,
      showfilter: false,
      showreport: false,
      report_data: [],
      selected_period: 0,
      disableme: false,
      report_from_date:'',
      report_to_date:'',
      instrument_type:null,
      numbers:['Interest Rate','Coupon Interest Rate','Face Value','Opening Carrying Amount','Investment Made During The Period','Interest Accrued During The Period','Interest Received During The Period','Encashment During The Period','Closing Carrying Amount','Interest Received Period','Amortization of Investment','Coupon Payment Period'],
      show_personal_info_choice:false,
      show_personal_info: true,
      column_selected:[],
      column_options:[],
    };
  },
  created() {
    this.showfilter = true;

    // Start: Rejwan: 29-11-2025
    if (this.$cookies.isKey("report_column_selected")) {
        const selected = this.$cookies.get("report_column_selected");
      
        if(selected == null || selected == '')
        {
            // selected =  "pin_number,employee_code,name,division,'date_of_joining',pf_start_date,pf_end_date,'pf_membership_period',status";
            selected =  "pin_number,employee_code,name,joining_date,pf_start_date,status";
        }

        if (selected != null && typeof selected === 'string') {
            this.column_selected = selected.split(',');
        } else if (Array.isArray(selected)) {
            // In case it's already an array (some cookie plugins serialize objects/arrays)
            this.column_selected = selected;
        } else {
            console.warn("Unexpected cookie type for 'report_column_selected':", selected);
            this.column_selected = [];
        }
        
    }

    if(this.column_selected.length == 0)
    {
        // const selected  = "pin_number,employee_code,name,division,'date_of_joining',pf_start_date,pf_end_date,'pf_membership_period',status";
        const selected  = "pin_number,employee_code,name,joining_date,pf_start_date,status";
        this.column_selected = selected.split(',');
    }
    // End: Rejwan: 29-11-2025
    
    if(this.$acl['employee/personal-info'] >= 2)
    {
        this.show_personal_info = true;
        this.show_personal_info_choice = true;

    }
    else
    {
        this.show_personal_info = false;
    }

    this.getPayrollDefaultField();
  },
  methods: {
   
    onDatesChanged(data) {
            if (data.sectionId === 'report') {
            this.report_from_date = data.fromDate;
            this.report_to_date = data.toDate;
        } else if (data.sectionId === 'comparison') {
            this.comparison_from_date = data.fromDate;
            this.comparison_to_date = data.toDate;
        }
        
    },

   
    generateReport(f) {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        
        let formData = new FormData();
        if(this.selected_reporttype == 10)
        {   
            formData.append("category", 1);
        }
        else if(this.selected_reporttype == 11)
        {
            formData.append("category", 2);
        }
        if(this.is_audit == 1)
        {   
            formData.append("audit_id", this.audit_id);
        }
    
       
        if(this.column_selected.indexOf('name') === -1){
            this.column_selected.unshift('name');
        }

        formData.append('column_selected', this.column_selected);
        formData.append('show_personal_info', this.show_personal_info); // Sifat: 04-08-2025 Add Personal info filer to pf report
        
        formData.append("from_date", this.report_from_date);
        formData.append("to_date", this.report_to_date);
        formData.append("downloadreport", f);

        this.showoverlay = true;

        if (f === 0) {
          axios.post(this.$api_url + '/pf/report/statement-of-members', formData)
            .then(response => {
              this.report_data = response.data; 
              this.showoverlay = false;
              this.showreport = true;
            })
            .catch(error => {
              this.serverError(error);
              this.showoverlay = false;
            });
        } else {
          const config = {
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            responseType: 'blob'
          };

          axios.post(this.$api_url + '/pf/report/statement-of-members', formData, config)
            .then(response => {
              const contentDisposition = response.headers['content-disposition'];
              const fileName = contentDisposition?.split(';')[1]?.trim().split('=')[1] || 'report.xlsx';
              const blob = new Blob([response.data], { type: response.headers['content-type'] });
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.showoverlay = false;
            })
            .catch(error => {
              this.serverError(error);
              this.showoverlay = false;
            });
        }
      });
    },
    getCurrentFinancialYear() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      return month < 7 ? `${year - 1}-${year}` : `${year}-${year + 1}`;
    },

    getPayrollDefaultField()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
          params: {
              flag:'pf_report',
          }

      }).then(function(response){
          this.default_fields = response.data;
          let available_colunms = [];

          let co = [];
          var txt = '';
          this.default_fields.forEach(element => {


              if(element=='etin')
              {
                  txt = 'e-TIN';
              }
              else if(element=='jobposition')
              {
                  txt = 'Job Position';
              }
              else if(element=='nid')
              {
                  txt = 'NID';
              }
              else if(element=='branch')
              {
                  txt = 'Work Location';
              }
              else if(element=='pf_start_date')
              {
                  txt = 'PF Start Date';
              }
              else if(element=='pf_end_date')
              {
                  txt = 'PF End Date';
              }
              // Start: Rejwan: 29-11-2025 Column Selection
              else if(element=='employee_code')
              {
                  txt = 'Alias Id';
              }
              // End: Rejwan: 29-11-2025 Column Selection
              else
              {
                  txt = this.stringView(element);
              }
              co = co.concat([{ text: txt , value: element }]);
              
              

              available_colunms = available_colunms.concat(element);
          }); 

          this.column_options = this.column_options.concat(co);


          let final_column_selected = [];
          this.column_selected.forEach(element => 
          {
              if(available_colunms.includes(element))
              {

                  final_column_selected.push(element);
              }
              else
              {
                  
              }
          }); 
          this.column_selected = final_column_selected;

      }.bind(this));
    },
    stringView(str) {
      if(str == 'etin')
      {
          return 'e-TIN';
      }
      // Start: Rejwan: 29-11-2025
      else if(str == 'employee_code')
      {
          return 'Alias Id'
      }
      // End: Rejwan: 29-11-2025
      var i, frags = str.split('_');
      for (i=0; i<frags.length; i++) {
          frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    setcolumn: function()
    {
        this.$cookies.set("report_column_selected", this.column_selected);
        
        this.$refs.dropdown.hide(true);
    },
    capitalizeTheFirstLetterOfEachWord(words) {
      var separateWord = words.toLowerCase().split(' ');
      for (var i = 0; i < separateWord.length; i++) {
          separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
          separateWord[i].substring(1);
      }
      return separateWord.join(' ');
    }
  },
 
};
</script>

<style scoped>
.full-overlay {
  height: 100% !important;
}
</style>
